export default __webpack_public_path__ + "static/itreview-banner-pc-749f54fa7e07bbffc07111b6d3b04264.png";